import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { notifyError } from "../../utils/notifications";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { BenchmarkCard } from "./BenchmarkCard";
function formatLevelText(level) {
    const periodMap = {
        ThirtyDays: "30 days",
        SevenDays: "7 days",
        CalendarMonth: "calendar month",
    };
    return `${level.NcDays} nc in any ${periodMap[level.InPeriod] ?? ""}`;
}
export function LevelsInformation() {
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let isDisposed = false;
        fetch("/api/dashboard/companylevels")
            .then((response) => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
            .then((data) => {
            if (isDisposed) {
                return;
            }
            setSettings(data.map((item) => ({
                Company: item.Company,
                Level1: formatLevelText(item.CompanyLevels.Level1),
                Level2: formatLevelText(item.CompanyLevels.Level2),
                Level3: formatLevelText(item.CompanyLevels.Level3),
                CompanyLevels: item.CompanyLevels,
            })));
        })
            .catch(() => {
            if (!isDisposed) {
                notifyError("An error has occurred when loading company levels. Please try again.");
            }
        })
            .finally(() => {
            if (!isDisposed) {
                setLoading(false);
            }
        });
        return () => {
            isDisposed = true;
        };
    }, []);
    if (loading) {
        return _jsx(WkoLoadingSpinner, {});
    }
    return (_jsxs(BenchmarkCard, { bodyClassName: "pt-3", children: [_jsx("h2", { children: "NC levels thresholds" }), _jsxs("p", { className: "small", children: ["The thresholds are defined per company. Please contact", " ", _jsx("a", { href: "mailto:support@isfwatchkeeper.com", children: "support@isfwatchkeeper.com" }), " to update the settings for your company"] }), _jsx("div", { className: "d-flex flex-wrap gap-3", children: settings.map((item) => (_jsxs("div", { style: { minWidth: "200px" }, children: [_jsx("span", { children: item.Company }), _jsxs("div", { className: "my-1 l1-highlighter mx-n2 px-2", children: [_jsx("span", { className: "badge rounded-pill badge-l1 me-2", children: "Level 1" }), _jsx("span", { children: item.Level1 })] }), _jsxs("div", { className: "my-1 l2-highlighter mx-n2 px-2", children: [_jsx("span", { className: "badge rounded-pill badge-l2 me-2", children: "Level 2" }), _jsx("span", { children: item.Level2 })] }), _jsxs("div", { className: "my-1 l3-highlighter mx-n2 px-2", children: [_jsx("span", { className: "badge rounded-pill badge-l3 me-2", children: "Level 3" }), _jsx("span", { children: item.Level3 }), item.CompanyLevels.Count7DaysNcAsLevel3 && _jsx("span", { children: " (+ any 7-day deviations)" })] }), _jsxs("div", { className: "my-1 l4-highlighter mx-n2 px-2", children: [_jsx("span", { className: "badge rounded-pill badge-l4 me-2", children: "Level 4" }), _jsx("span", { children: item.CompanyLevels.ConsecutiveNumberOfDays }), " consecutive nc"] })] }, item.Company))) })] }));
}
